import { Box, Stack, Card, CardHeader, Avatar, Divider, Typography } from "@mui/material"
import { useEffect, useState } from "react"
import { apiService } from "../apiService"
import { AuditTrailReadModel, InvoiceReadModel } from "../GeneratedClients/FreeBillApi"
import { DateField, useRecordContext, useTranslate } from "react-admin"
import firstLetterToLowerCase from "../helpers/firstLetterToLowerCase"
import MapEventToIcon from "../auditTrails/MapEventToIcon"

const AuditTrail = () => {

  const [auditTrialActions, setAuditTrialActions] = useState<AuditTrailReadModel[]>()
  const translate = useTranslate()
  const record: InvoiceReadModel = useRecordContext()
  
  const fetchAuditTrail = async() => {
    try {
      const {data} = await apiService.AuditTrailApi.getAllByEventId({eventId: record.id!})
      setAuditTrialActions(data)  
    } catch (error) {
    }
  }

  useEffect(() => {
    fetchAuditTrail()
  }, [record])

  const invoiceCreatedExists = auditTrialActions?.some(x => x.eventName === "InvoiceCreated")

  if(!record) return null

  return (
    <Box width={"100%"} >
      <Typography variant="h6">Rechnungshistorie:</Typography>
      {
        (!auditTrialActions || auditTrialActions.length === 0) && 
        <Typography variant="body2" my={2}>Für diese Rechnung gibt es leider noch keine Historie.</Typography>
      }
      {
        auditTrialActions && auditTrialActions.length > 0 && !invoiceCreatedExists && <Typography variant="body2" my={2} >Hinweis: Die Historie für diese Rechnung ist nicht vollständig.</Typography>
      }
      <Stack 
        direction={"column"}
        alignItems={"flex-start"}
      >
        {
          auditTrialActions?.map((auditTrailAction: AuditTrailReadModel, index: number) => (
            <>
              { index !== 0 && <Divider sx={{height: 20, ml: 4.5}} orientation="vertical" variant="middle" /> }
              <Card sx={{width: "100%"}}>
                <CardHeader 
                  avatar={<Avatar>{MapEventToIcon(auditTrailAction.eventName)}</Avatar>}
                  title={translate(`resources.auditTrail.${firstLetterToLowerCase(auditTrailAction.eventName)}`)}
                  subheader={
                    <>
                      <DateField record={auditTrailAction} source="eventOccuredAt" showTime />
                      <Typography variant="body2" whiteSpace={"pre-wrap"}>{auditTrailAction.information}</Typography>
                    </>
                  }
                />
              </Card>
            </>
          ))
        }
      </Stack>
    </Box>
  )
}


export default AuditTrail